import React, { useEffect } from 'react';
import { SelfTestResultProps } from '../../../../components/self-test/model/SelfTestResultProps';
import './self-test-result.scss';
import { UrlService } from '../../../../core/services/UrlService';
import { result } from '../data/result';
import { TrackingService } from '../../../../core/services/TrackingService';

const SelfTestResult: React.FC<SelfTestResultProps> = (props: SelfTestResultProps) => {
    const handleResetClick = (ev: any) => {
        props.onReset();
    }

    const [risk, setRisk] = React.useState<boolean>(false);

    const handleSRPButtonClick = (type: 'neurologists' | 'neurosurgeon') => {
        TrackingService.trackSelftest(props.questions.analytics.slug, `srp_${type}`, props.questions.analytics.resultText(props.answers));
    };

    const defaultItmQuery = {
        itm_source: `self-tests_risk-${risk? 'high' : 'low'}`, 
        itm_medium: 'srp_button', 
        itm_campaign: props.questions.analytics.slug,
    };

    useEffect(() => {
        setRisk(result(props.answers).risk);
    }, [props.answers])

    return (
        <div id='result' className="self-test__test-result">
            <div className="__container">
                <div className="__section __section1">
                    <div className="__overhead">
                        <div className="__overhead-box">
                            評分機制及結果
                        </div>
                    </div>
                    <div className="__line1">
                        根據您的回答
                    </div>
                    <div className="__line2">
                        {
                            risk &&
                            <>
                                您膽固醇超標的風險較高，
                                <br />
                                需要多加留意！
                            </>
                        }
                        {
                            !risk && `您膽固醇超標的風險較低。`
                        }
                    </div>
                    <div className="__line3">
                        {
                            risk &&
                            <>
                                膽固醇過高有機會引致中風，導致各種程度的殘障，
                                <br />
                                如半身不遂、說話困難等，嚴重更可能會昏迷或死亡<sup>2,10</sup>。
                            </>
                        }
                        {
                            !risk && `雖然您的風險較低，定期檢測及預防仍是十分重要。`
                        }
                    </div>
                </div>
                {
                    risk &&
                    <div className="__section __section2a">
                        <div className="__float-container">
                            <div className="__image">
                                <img src={UrlService.getLocalImageUrl('self-test/cholesterol/a1a.png')}></img>
                            </div>
                                除了改善生活習慣，如戒煙、多做運動等<sup>2</sup>，您應諮詢醫生意見進行驗血，得知各類膽固醇的水平<sup>4</sup>。
                                醫生亦有機會處方不同降膽固醇藥物。降膽固醇藥可分為他汀類及非他汀類藥物。
                                他汀類藥物(Statin)可減少肝臟製造膽固醇，令肝臟從血液中吸取膽固醇<sup>3</sup>。
                                但若患者已接受最高耐受劑量他汀，仍未能有效控制壞膽固醇，便要考慮結合其他藥物控制，如抑制PCSK9的藥物<sup>17</sup>。
                                抑制PCSK9 可令更多壞膽固醇收回到肝臟，並進行分解，降低壞膽固醇水平<sup>18</sup>，從而減低患上中風的風險<sup>19</sup>。
                        </div>
                    </div>
                }
                {
                    !risk && 
                    <div className="__section __section2b">
                        <div className="__text">
                            <div className="__line1">
                                除了定期檢測，您亦應注意<br></br>生活習慣，如<sup>2</sup>：
                            </div>
                            <div className="__line2">
                                <li>多做體能活動</li>
                                <li>均衡飲食，減少進食飽和及反式脂肪含量高的食物</li>
                            </div>
                        </div>
                        <div className="__image">
                            <img src={UrlService.getLocalImageUrl('self-test/cholesterol/a1b.png')}></img>
                        </div>
                    </div>
                }
                <div className="__section __section3" style={UrlService.getLocalImageUrlStyle('self-test/cholesterol/a2.png')}>
                    <div className="__text">
                        <div className="__line1">
                            {
                                risk && (
                                    <>中風是香港第四號「致命殺手」，每年超過三千港人死於中風<sup>9</sup>。切勿掉以輕心，及早網上預約專科醫生，尋求專業協助！</>
                                )
                            }
                            {
                                !risk && `如想知道更多自己／家人如何預防膽固醇超標，您可網上預約專科醫生，尋求專業協助。`
                            }
                        </div>
                        <div className="__line2">
                            <a target='_blank' href={TrackingService.getNavigateUrlWithITMQuery('https://www.finddoc.com/doctors/cholesterol-neurologists', defaultItmQuery)} onClick={() => handleSRPButtonClick('neurologists')}><button>預約腦神經科醫生</button></a>
                        </div>
                        <div className="__line3">
                            <a target='_blank' href={TrackingService.getNavigateUrlWithITMQuery('https://www.finddoc.com/doctors/cholesterol-neurosurgeon', defaultItmQuery)} onClick={() => handleSRPButtonClick('neurosurgeon')}><button>預約神經外科醫生</button></a>
                        </div>
                    </div>
                </div>
                <button onClick={handleResetClick}>
                    重新評估
                </button>
            </div>
        </div >
    );
};

export default SelfTestResult;
